import { ErrorSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

export const ImportRuleSchema = z.object({
  adAccountId: z.string(),
  tileSettingsId: z.string(),
  value: z.string(),
  type: z.string(),
  field: z.string(),
  id: z.string().optional(),
  userUpdatedAt: z.string().optional().nullable(),
  userUpdatedId: z.number().optional().nullable(),
});

export const ImportRuleQuerySchema = z.object({
  tileSettingsId: z.string(),
});

export const ImportRuleResponseSchema = z.object({
  data: z
    .object({
      items: z.array(ImportRuleSchema),
    })
    .optional(),
  error: ErrorSchema.optional(),
});
